import React, { useState, useEffect } from 'react';

function CookieBanner() {
	const [showBanner, setShowBanner] = useState(false);

	useEffect(() => {
		// Prüfen ob Cookie-Einwilligung bereits erteilt wurde
		const cookieConsent = localStorage.getItem('cookieConsent');
		if (!cookieConsent) {
			setShowBanner(true);
		}
	}, []);

	const acceptCookies = () => {
		localStorage.setItem('cookieConsent', 'accepted');
		setShowBanner(false);
	};

	const declineCookies = () => {
		localStorage.setItem('cookieConsent', 'declined');
		setShowBanner(false);
	};

	if (!showBanner) {
		return null;
	}

	return (
		<div className="cookie-banner position-fixed bottom-0 start-0 end-0 bg-primary text-white p-3 shadow-lg" style={{ zIndex: 1050 }}>
			<div className="container">
				<div className="row align-items-center">
					<div className="col-md-8">
						<p className="mb-0">
							<strong>Cookie-Hinweis:</strong> Diese Website verwendet derzeit keine Cookies. Falls in Zukunft Cookies eingesetzt werden, werden Sie hierüber informiert. Weitere Informationen finden Sie in unserer{' '}
							<a href="/datenschutz" className="text-white text-decoration-underline">
								Datenschutzerklärung
							</a>
							.
						</p>
					</div>
					<div className="col-md-4 text-end">
						<button className="btn btn-outline-light btn-sm me-2" onClick={declineCookies}>
							Ablehnen
						</button>
						<button className="btn btn-light btn-sm" onClick={acceptCookies}>
							Verstanden
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}

export default CookieBanner;
